module.exports = __webpack_public_path__ + "static/media/navBar-report.635d95e0.svg";